import React from 'react';
import { useTranslate } from '@hooks';
import { Card, CardBody, Row, Col } from 'reactstrap';
import { DetailsBlock, List, FlexContainer } from '@dotone/react-ui-core';
import InviteAction from './MarketplaceInviteAction';
import { formatAffiliateType } from '../Affiliates/formatters';
import {
  formatAffiliate,
  formatRating,
  formatEarningRating,
  formatCampaignMetrics,
  formatSiteInfos,
} from '../formatters';

const MarketplaceItem = ({ item, offerId }) => {
  const { t, tHint } = useTranslate('marketplace', 'model');
  const {
    siteInfos,
    country,
    loginRating,
    clickRating,
    conversionRating,
    earningRating,
    campaignMetrics,
    categoryGroups,
  } = item;

  return (
    <Card>
      <CardBody>
        <Row>
          <Col sm={3}>
            <FlexContainer column align="center" justify="center" className="h-100">
              {formatAffiliate(item, { avatarWidth: 80 })}
            </FlexContainer>
          </Col>
          <Col sm={6}>
            <FlexContainer column justify="center" className="h-100">
              <DetailsBlock
                label={t('categoryGroups')}
                content={categoryGroups.length && <List items={categoryGroups} />}
              />
              <DetailsBlock
                label={t('mediaCategories')}
                content={formatAffiliateType(null, item)}
              />
              {!!siteInfos.length && (
                <DetailsBlock
                  label={t('siteInfos')}
                  content={formatSiteInfos(siteInfos, { canAccess: true })}
                />
              )}
              <FlexContainer justify="space-between" className="w-100">
                <DetailsBlock label={t('region')} content={country?.region} />
                <InviteAction affiliate={item} offerId={offerId} />
              </FlexContainer>
            </FlexContainer>
          </Col>
          <Col sm={3}>
            <FlexContainer column justify="center" className="h-100">
              <DetailsBlock
                label={t('affiliate:model.loginRating')}
                labelProps={{
                  hintProps: {
                    ...tHint('affiliate:hints.loginRating'),
                    tKey: `login-rating-${item.id}`,
                  },
                }}
                content={formatRating(loginRating, item)}
              />
              <DetailsBlock
                label={t('affiliate:model.clickRating')}
                labelProps={{
                  hintProps: {
                    ...tHint('affiliate:hints.clickRating'),
                    tKey: `click-rating-${item.id}`,
                  },
                }}
                content={formatRating(clickRating, item)}
              />
              <DetailsBlock
                label={t('affiliate:model.conversionRating')}
                labelProps={{
                  hintProps: {
                    ...tHint('affiliate:hints.conversionRating'),
                    tKey: `conversion-rating-${item.id}`,
                  },
                }}
                content={formatRating(conversionRating, item)}
              />
              <DetailsBlock
                label={t('affiliate:model.campaignMetrics')}
                content={formatCampaignMetrics(campaignMetrics, item)}
              />
              <DetailsBlock
                label={t('affiliate:model.earningRating')}
                content={formatEarningRating(earningRating, item, t)}
              />
            </FlexContainer>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default MarketplaceItem;
